const AGENTIC_GENERATION_PATHS = new Set([
  "/api/ai/agenticChat/message",
  "/api/ai/agenticChat/message/replace",
  "/api/ai/agenticChat/plan/approve",
  "/api/ai/agenticChat/plan/resume",
  "/api/ai/agenticChat/generateTitle",
].map((path) => path.toLowerCase()));

const NON_GENERATION_PATHS = new Set([
  "/api/ai/convertProjectToScenes",
  "/api/ai/storyEngine/classifyGenre",
  "/api/ai/storyEngine/style/featured-styles",
  "/api/ai/storyEngine/write/estimateChapter",
].map((path) => path.toLowerCase()));

export function isGenerationRequest(req: { method: string }, pathname: string): boolean {
  // Express routes are case-insensitive by default.
  const route = pathname.toLowerCase();
  if (req.method !== "POST" || !route.startsWith("/api/ai/")) return false;
  // Chat also serves history, recovery, cancellation, and edits to existing writing.
  if (route.startsWith("/api/ai/agenticchat/")) return AGENTIC_GENERATION_PATHS.has(route);
  return !NON_GENERATION_PATHS.has(route);
}
